import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';

import { Alert, Box, Button, CircularProgress, Snackbar } from '@mui/material';

import API from 'app/API';
import useStores from 'hooks/use-stores';
import Hubspot from 'main/common/Hubspot';

import useStyles from './styles';

const CreateButton = ({ onCreate, scope }) => {
    const { classes } = useStyles();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const { userStore } = useStores();

    const handleClick = useCallback(() => {
        setIsLoading(true);
        const freeLicense = userStore.licenseList.find(({ licenseType }) => licenseType === 'free');
        if (!freeLicense) {
            return setError('You have no suitable license, please, contact support');
        }
        API.fetchWithToken(API.KEY_CREATE, {
            scope: [scope],
            ipaddressList: [],
            licenseId: freeLicense.id
        }).then(({ result, data }) => {
            setIsLoading(false);
            if (result === 'error') {
                setError(data.error);
            } else {
                Hubspot.send(Hubspot.API_KEY_CREATED, { email: userStore.user.email });
                userStore.loadApiKeys(() => {
                    const [apiKey] = userStore.apiKeys;
                    onCreate && onCreate(apiKey);
                });
            }
        });
    }, [onCreate, scope, userStore]);

    const handleClearError = useCallback(() => setError(null), []);

    return (
        <Box className={classes.container}>
            <Box>
                {`Click to generate new API key for ${scope} or follow to `}
                <Link className={classes.link} to="/userinfo">
                    {'Advanced key management'}
                </Link>
                {' interface'}
            </Box>

            <Button
                color="primary"
                variant="contained"
                onClick={handleClick}
                className={classes.button}
                disabled={isLoading}
            >
                {isLoading ? <CircularProgress size={16} /> : 'Generate new Key'}
            </Button>
            {error && (
                <Snackbar
                    autoHideDuration={3000}
                    open={Boolean(error)}
                    message={error}
                    onClose={handleClearError}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                >
                    <Alert elevation={6} severity={'error'}>
                        {error}
                    </Alert>
                </Snackbar>
            )}
        </Box>
    );
};

CreateButton.propTypes = {
    onCreate: PropTypes.func,
    scope: PropTypes.string
};

export default observer(CreateButton);
